import { create } from "zustand";
import { devtools } from "zustand/middleware";

type State = {
  isReadyGenerator: boolean;
  isReadyToPost: boolean;
  isRamadanDate: boolean;
  isOnChangeInHijra: boolean;

  isRamadan:{
    ramadan:boolean,
    zuhrEnd:string,
    iftarStart:string,
    ramadan_custom:number
  }
};

type Action = {
  updateIsReadyGenerator: (isReadyGenerator: State["isReadyGenerator"]) => void;
  updateIsReadyToPost: (isReadyToPost: State["isReadyToPost"]) => void;
  updateIsRamadan: (isRamadan: State["isRamadan"]) => void;
  updateIsOnChangeInHijra: (isOnChangeInHijra: State["isOnChangeInHijra"]) => void;
  updateIsRamadanDate: (isRamadanDate: State["isRamadanDate"]) => void;
};

// Create your store, which includes both state and (optionally) actions
export const useConditional = create<State & Action>()(
  devtools((set) => ({
   

    isReadyGenerator: false,
    isReadyToPost: false,
    isRamadanDate: false,
    isOnChangeInHijra: false,
    isRamadan:{
      ramadan:false,
      zuhrEnd:"Zuhr End",
      iftarStart:"Iftar Start",
      ramadan_custom:0
    },

    updateIsReadyGenerator: (isReadyGenerator) =>
      set(() => ({ isReadyGenerator: isReadyGenerator })),
    updateIsReadyToPost: (isReadyToPost) =>
      set(() => ({ isReadyToPost: isReadyToPost })),
    updateIsRamadan: (isRamadan) =>
      set(() => ({ isRamadan: isRamadan })),
    updateIsOnChangeInHijra: (isOnChangeInHijra) =>
      set(() => ({ isOnChangeInHijra: isOnChangeInHijra })),
    updateIsRamadanDate: (isRamadanDate) =>
      set(() => ({ isRamadanDate: isRamadanDate })),

  }),{name:"storeConditional"})

  
);
